import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: true,
    options: {
      customProperties: true
    },
    themes: {
      dark: {
        primary: '#28bcea',
        secondary: '#152f7c',
        accent: '#f5c347',
        error: '#ff6b6b',
        info: '#28bcea',
        success: '#f5c347',
        warning: '#f5c347',
        background: '#060f23',
        surface: '#0f1419'
      },
      light: {
        primary: '#152f7c',
        secondary: '#28bcea',
        accent: '#f5c347',
        background: '#f5f5f5',
        surface: '#ffffff'
      }
    }
  }
});
